'use client'

import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'

export default function ConditionalMain({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  const isStudioPage = pathname?.startsWith('/studio')
  const isAuthPage = pathname?.startsWith('/login') || 
                     pathname?.startsWith('/register') || 
                     pathname?.startsWith('/fanbasis-register') || 
                     pathname?.startsWith('/forgot-password') ||
                     pathname?.startsWith('/reset-password')

  if (isAuthPage) {
    return (
      <main className="flex-1 min-h-screen">
        {children}
      </main>
    )
  }

  if (isStudioPage) {
    return (
      <main className="flex-1 mt-[72px] p-3 sm:p-4 md:p-6 min-h-screen">
        {children}
      </main>
    )
  }

  return (
    <main className="flex-1 mt-[72px]">
      {children}
    </main>
  )
}
